﻿(function (w, d, $) {
    $(d).ready(function () {
        $(".thumbnail-promo.match-height").each(function () {
            $(this).find(".promo-item").matchHeight({
                byRow: true
            });
        });
    });
})(window, document, jQuery);